(function () {
	'use strict';

	angular.module('sempraWebapp').factory('DashboardKarcherTechnologyViewModel', DashboardKarcherTechnologyViewModelFactory);

	/** @ngInject */
	function DashboardKarcherTechnologyViewModelFactory($translate) {
		function DashboardKarcherTechnologyViewModel() {
			this.siteName = "";
			this.alarmStatusList = [
				{
					name: $translate.instant("LOW_ALARM"),
					value: "INFO"
				},
				{
					name: $translate.instant("MEDIUM_ALARM"),
					value: "WARNING"
				},
				{
					name: $translate.instant("HIGH_ALARM"),
					value: "ALARM"
				}
			];
			this.facilityAlarmStatuses = [];
			this.alarmStatus = "";
			this.alarmHigh = 0;
			this.alarmLow = 0;
			this.alarmMedium = 0;
			this.alarmTotal = 0;
			this.mapStyleSelector = false;
			this.buttonTitleOnMapModal = $translate.instant("BREAD_CRUMBS_DETAILS");
			this.mapStyles = [
				{
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f5f5f5"
						}
					]
				},
				{
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#616161"
						}
					]
				},
				{
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"color": "#f5f5f5"
						}
					]
				},
				{
					"featureType": "administrative.land_parcel",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#bdbdbd"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#eeeeee"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#757575"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e5e5e5"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#757575"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#dadada"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#616161"
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				},
				{
					"featureType": "transit.line",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e5e5e5"
						}
					]
				},
				{
					"featureType": "transit.station",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#eeeeee"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#c9c9c9"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				}
			]
			this.templateContentTranslate = {
				address: $translate.instant('ADDRESS'),
				info: $translate.instant('INFO_TITLE'),
				phone: $translate.instant('PHONE'),
				workingHours: $translate.instant('WORKING_HOURS')
			}
		}

		DashboardKarcherTechnologyViewModel.prototype.destroy = function () {

		};

		DashboardKarcherTechnologyViewModel.prototype.refreshAlarmsOnMapPage = function (data) {
			this.alarmHigh = data.high;
			this.alarmLow = data.low;
			this.alarmMedium = data.medium;
			this.alarmTotal = data.total;
		};

		DashboardKarcherTechnologyViewModel.prototype.refreshFacilityAlarmStatuses = function (data) {
			this.facilityAlarmStatuses = data.facilityAlarmStatuses;
		};

		return DashboardKarcherTechnologyViewModel;
	}
})();
